export const ApiConfig = {
    apiKey: '70fa4548-68ba-4a29-88b9-8df5ba218453'
}